import { render, staticRenderFns } from "./TimeFrame.vue?vue&type=template&id=6770407f&"
import script from "./TimeFrame.vue?vue&type=script&lang=js&"
export * from "./TimeFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports